/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetOrgStatusesQueryVariables = Types.Exact<{
  orgId: Types.Scalars["OrgId"]["input"];
}>;

export type GetOrgStatusesQuery = {
  readonly __typename: "Query";
  readonly orgById: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly allowMagic: boolean;
    readonly defaultStatusId: c.StatusId | null;
    readonly statuses: ReadonlyArray<{
      readonly __typename: "Status";
      readonly id: c.StatusId;
      readonly name: string;
      readonly color: Types.HexColor;
      readonly inLibrary: boolean;
      readonly hexCount: number;
      readonly description: string | null;
      readonly order: string;
      readonly endorsed: boolean;
      readonly enforcesReview: boolean;
      readonly icon: Types.IconType | null;
    }>;
  };
};

export type CreateStatusMutationVariables = Types.Exact<{
  name: Types.Scalars["String"]["input"];
  color: Types.HexColor;
  inLibrary: Types.Scalars["Boolean"]["input"];
  orgId: Types.Scalars["OrgId"]["input"];
  description: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  endorsed: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  enforcesReview: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  icon: Types.InputMaybe<Types.IconType>;
}>;

export type CreateStatusMutation = {
  readonly __typename: "Mutation";
  readonly createStatus: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly statuses: ReadonlyArray<{
      readonly __typename: "Status";
      readonly id: c.StatusId;
      readonly name: string;
      readonly color: Types.HexColor;
      readonly inLibrary: boolean;
      readonly description: string | null;
      readonly order: string;
      readonly endorsed: boolean;
      readonly enforcesReview: boolean;
      readonly icon: Types.IconType | null;
    }>;
  };
};

export type UpdateStatusMutationVariables = Types.Exact<{
  statusId: Types.Scalars["StatusId"]["input"];
  name: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  color: Types.InputMaybe<Types.HexColor>;
  inLibrary: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  description: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  order: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  endorsed: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  enforcesReview: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  icon: Types.InputMaybe<Types.IconType>;
}>;

export type UpdateStatusMutation = {
  readonly __typename: "Mutation";
  readonly updateStatus: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly statuses: ReadonlyArray<{
      readonly __typename: "Status";
      readonly id: c.StatusId;
      readonly name: string;
      readonly color: Types.HexColor;
      readonly inLibrary: boolean;
      readonly description: string | null;
      readonly order: string;
      readonly endorsed: boolean;
      readonly enforcesReview: boolean;
      readonly icon: Types.IconType | null;
    }>;
  };
};

export type UpdateOrgDefaultStatusMutationVariables = Types.Exact<{
  orgId: Types.Scalars["OrgId"]["input"];
  defaultStatusId: Types.InputMaybe<Types.Scalars["StatusId"]["input"]>;
}>;

export type UpdateOrgDefaultStatusMutation = {
  readonly __typename: "Mutation";
  readonly updateOrgDefaultStatus: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly defaultStatusId: c.StatusId | null;
  };
};

export type DeleteStatusMutationVariables = Types.Exact<{
  statusId: Types.Scalars["StatusId"]["input"];
}>;

export type DeleteStatusMutation = {
  readonly __typename: "Mutation";
  readonly deleteStatus: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly statuses: ReadonlyArray<{
      readonly __typename: "Status";
      readonly id: c.StatusId;
      readonly name: string;
      readonly color: Types.HexColor;
      readonly inLibrary: boolean;
      readonly description: string | null;
      readonly order: string;
      readonly endorsed: boolean;
      readonly enforcesReview: boolean;
      readonly icon: Types.IconType | null;
    }>;
  };
};

export const GetOrgStatusesDocument = /*#__PURE__*/ gql`
  query GetOrgStatuses($orgId: OrgId!) {
    orgById(orgId: $orgId) {
      id
      allowMagic
      defaultStatusId
      statuses {
        id
        name
        color
        inLibrary
        hexCount
        description
        order
        endorsed
        enforcesReview
        icon
      }
    }
  }
`;

/**
 * __useGetOrgStatusesQuery__
 *
 * To run a query within a React component, call `useGetOrgStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgStatusesQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetOrgStatusesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOrgStatusesQuery,
    GetOrgStatusesQueryVariables
  > &
    (
      | { variables: GetOrgStatusesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOrgStatusesQuery, GetOrgStatusesQueryVariables>(
    GetOrgStatusesDocument,
    options,
  );
}
export function useGetOrgStatusesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrgStatusesQuery,
    GetOrgStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOrgStatusesQuery, GetOrgStatusesQueryVariables>(
    GetOrgStatusesDocument,
    options,
  );
}
export function useGetOrgStatusesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetOrgStatusesQuery,
    GetOrgStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetOrgStatusesQuery,
    GetOrgStatusesQueryVariables
  >(GetOrgStatusesDocument, options);
}
export type GetOrgStatusesQueryHookResult = ReturnType<
  typeof useGetOrgStatusesQuery
>;
export type GetOrgStatusesLazyQueryHookResult = ReturnType<
  typeof useGetOrgStatusesLazyQuery
>;
export type GetOrgStatusesSuspenseQueryHookResult = ReturnType<
  typeof useGetOrgStatusesSuspenseQuery
>;
export type GetOrgStatusesQueryResult = Apollo.QueryResult<
  GetOrgStatusesQuery,
  GetOrgStatusesQueryVariables
>;
export const CreateStatusDocument = /*#__PURE__*/ gql`
  mutation CreateStatus(
    $name: String!
    $color: HexColor!
    $inLibrary: Boolean!
    $orgId: OrgId!
    $description: String
    $endorsed: Boolean
    $enforcesReview: Boolean
    $icon: IconType
  ) {
    createStatus(
      name: $name
      color: $color
      inLibrary: $inLibrary
      orgId: $orgId
      description: $description
      endorsed: $endorsed
      enforcesReview: $enforcesReview
      icon: $icon
    ) {
      id
      statuses {
        id
        name
        color
        inLibrary
        description
        order
        endorsed
        enforcesReview
        icon
      }
    }
  }
`;
export type CreateStatusMutationFn = Apollo.MutationFunction<
  CreateStatusMutation,
  CreateStatusMutationVariables
>;

/**
 * __useCreateStatusMutation__
 *
 * To run a mutation, you first call `useCreateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStatusMutation, { data, loading, error }] = useCreateStatusMutation({
 *   variables: {
 *      name: // value for 'name'
 *      color: // value for 'color'
 *      inLibrary: // value for 'inLibrary'
 *      orgId: // value for 'orgId'
 *      description: // value for 'description'
 *      endorsed: // value for 'endorsed'
 *      enforcesReview: // value for 'enforcesReview'
 *      icon: // value for 'icon'
 *   },
 * });
 */
export function useCreateStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateStatusMutation,
    CreateStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateStatusMutation,
    CreateStatusMutationVariables
  >(CreateStatusDocument, options);
}
export type CreateStatusMutationHookResult = ReturnType<
  typeof useCreateStatusMutation
>;
export type CreateStatusMutationResult =
  Apollo.MutationResult<CreateStatusMutation>;
export type CreateStatusMutationOptions = Apollo.BaseMutationOptions<
  CreateStatusMutation,
  CreateStatusMutationVariables
>;
export const UpdateStatusDocument = /*#__PURE__*/ gql`
  mutation UpdateStatus(
    $statusId: StatusId!
    $name: String
    $color: HexColor
    $inLibrary: Boolean
    $description: String
    $order: String
    $endorsed: Boolean
    $enforcesReview: Boolean
    $icon: IconType
  ) {
    updateStatus(
      statusId: $statusId
      name: $name
      color: $color
      inLibrary: $inLibrary
      description: $description
      order: $order
      endorsed: $endorsed
      enforcesReview: $enforcesReview
      icon: $icon
    ) {
      id
      statuses {
        id
        name
        color
        inLibrary
        description
        order
        endorsed
        enforcesReview
        icon
      }
    }
  }
`;
export type UpdateStatusMutationFn = Apollo.MutationFunction<
  UpdateStatusMutation,
  UpdateStatusMutationVariables
>;

/**
 * __useUpdateStatusMutation__
 *
 * To run a mutation, you first call `useUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStatusMutation, { data, loading, error }] = useUpdateStatusMutation({
 *   variables: {
 *      statusId: // value for 'statusId'
 *      name: // value for 'name'
 *      color: // value for 'color'
 *      inLibrary: // value for 'inLibrary'
 *      description: // value for 'description'
 *      order: // value for 'order'
 *      endorsed: // value for 'endorsed'
 *      enforcesReview: // value for 'enforcesReview'
 *      icon: // value for 'icon'
 *   },
 * });
 */
export function useUpdateStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateStatusMutation,
    UpdateStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateStatusMutation,
    UpdateStatusMutationVariables
  >(UpdateStatusDocument, options);
}
export type UpdateStatusMutationHookResult = ReturnType<
  typeof useUpdateStatusMutation
>;
export type UpdateStatusMutationResult =
  Apollo.MutationResult<UpdateStatusMutation>;
export type UpdateStatusMutationOptions = Apollo.BaseMutationOptions<
  UpdateStatusMutation,
  UpdateStatusMutationVariables
>;
export const UpdateOrgDefaultStatusDocument = /*#__PURE__*/ gql`
  mutation UpdateOrgDefaultStatus($orgId: OrgId!, $defaultStatusId: StatusId) {
    updateOrgDefaultStatus(orgId: $orgId, defaultStatusId: $defaultStatusId) {
      id
      defaultStatusId
    }
  }
`;
export type UpdateOrgDefaultStatusMutationFn = Apollo.MutationFunction<
  UpdateOrgDefaultStatusMutation,
  UpdateOrgDefaultStatusMutationVariables
>;

/**
 * __useUpdateOrgDefaultStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrgDefaultStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrgDefaultStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrgDefaultStatusMutation, { data, loading, error }] = useUpdateOrgDefaultStatusMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      defaultStatusId: // value for 'defaultStatusId'
 *   },
 * });
 */
export function useUpdateOrgDefaultStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOrgDefaultStatusMutation,
    UpdateOrgDefaultStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateOrgDefaultStatusMutation,
    UpdateOrgDefaultStatusMutationVariables
  >(UpdateOrgDefaultStatusDocument, options);
}
export type UpdateOrgDefaultStatusMutationHookResult = ReturnType<
  typeof useUpdateOrgDefaultStatusMutation
>;
export type UpdateOrgDefaultStatusMutationResult =
  Apollo.MutationResult<UpdateOrgDefaultStatusMutation>;
export type UpdateOrgDefaultStatusMutationOptions = Apollo.BaseMutationOptions<
  UpdateOrgDefaultStatusMutation,
  UpdateOrgDefaultStatusMutationVariables
>;
export const DeleteStatusDocument = /*#__PURE__*/ gql`
  mutation DeleteStatus($statusId: StatusId!) {
    deleteStatus(statusId: $statusId) {
      id
      statuses {
        id
        name
        color
        inLibrary
        description
        order
        endorsed
        enforcesReview
        icon
      }
    }
  }
`;
export type DeleteStatusMutationFn = Apollo.MutationFunction<
  DeleteStatusMutation,
  DeleteStatusMutationVariables
>;

/**
 * __useDeleteStatusMutation__
 *
 * To run a mutation, you first call `useDeleteStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStatusMutation, { data, loading, error }] = useDeleteStatusMutation({
 *   variables: {
 *      statusId: // value for 'statusId'
 *   },
 * });
 */
export function useDeleteStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteStatusMutation,
    DeleteStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteStatusMutation,
    DeleteStatusMutationVariables
  >(DeleteStatusDocument, options);
}
export type DeleteStatusMutationHookResult = ReturnType<
  typeof useDeleteStatusMutation
>;
export type DeleteStatusMutationResult =
  Apollo.MutationResult<DeleteStatusMutation>;
export type DeleteStatusMutationOptions = Apollo.BaseMutationOptions<
  DeleteStatusMutation,
  DeleteStatusMutationVariables
>;
